module.exports = __webpack_public_path__ + "img/12_001.cc0e332c.webp";